import React from 'react';

type SvgProps = {
  strokeColor?: string;
};

const MyCampaignIcon: React.FC<SvgProps> = ({ strokeColor = '#CBD2D9' }) => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.6666 21.334H21.3333"
      stroke={strokeColor}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M21.3333 12.0007V5.33398"
      stroke={strokeColor}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.66665 4L5.38093 12.2759C5.38093 12.2759 2.33331 13.1034 1.33331 14.6667"
      stroke={strokeColor}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.6666 22C14.6666 25.3088 11.6765 28 7.99998 28C4.32351 28 1.33331 25.2647 1.33331 22C1.33331 18.7353 4.32351 16 7.99998 16C11.6765 16 14.6666 18.7353 14.6666 22Z"
      stroke={strokeColor}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M28.9819 18.6673C29.4489 16.8667 29.729 14.5087 27.9545 13.9513C25.0126 12.9653 17.3075 11.8506 17.3075 11.8506L16 5.33398"
      stroke={strokeColor}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M30.6666 23.3327C30.6666 25.9059 28.5732 27.9993 26 27.9993C23.4268 27.9993 21.3333 25.9059 21.3333 23.3327C21.3333 20.7595 23.4268 18.666 26 18.666C28.5732 18.666 30.6666 20.7595 30.6666 23.3327Z"
      stroke={strokeColor}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.3333 4H5.33331"
      stroke={strokeColor}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default MyCampaignIcon;
